<template>
  <div class="containerOne" :style="cssProps">
    <alert ref="alert"></alert>
    <div class="search-item">
      <div class="search-block">
        <i class="fal fa-search"></i>
        <input type="search" placeholder="Search for food">
        <!-- <i
            class="far fa-location-arrow"
           
        ></i>-->
      </div>
    </div>
    <div class="categories d-flex flex-row justify-content-around">
      <!-- <div class="itemCat d-flex flex-row justify-content-around align-items-center" v-for="category in menu.categories" :key="category.id">
        <span>{{category.name}}</span>
        <img :src="category.images[0].url">
      </div> -->
       <!-- <div class="container-order" v-for="category in menu.categories" :key="category.id">
      <h1>{{category.name}}</h1>
      </div> -->
      <div class="itemCat d-flex flex-row justify-content-around align-items-center" v-for="category in menu.categories" :key="category.id">
        <span>{{category.name}}</span>
      </div>
      <!-- <div class="itemCat d-flex flex-row justify-content-around align-items-center">
        <span>Burgers</span>

       <i class="far fa-cheeseburger"></i>
      </div>
      <div class="itemCat d-flex flex-row justify-content-around align-items-center">
        <span>Hot Dogs</span>

        <i class="fas fa-hotdog"></i>
      </div>
      <div class="itemCat d-flex flex-row justify-content-around align-items-center">
        <span>Sandwiches</span>

        <i class="fal fa-sandwich"></i>
      </div>
      <div class="itemCat d-flex flex-row justify-content-around align-items-center">
        <span>Fries</span>

        <i class="fal fa-french-fries"></i>
      </div>
      <div class="itemCat d-flex flex-row justify-content-around align-items-center">
        <span>Drinks</span>

        <i class="fal fa-cocktail"></i>
      </div>
      <div class="itemCat d-flex flex-row justify-content-around align-items-center">
        <span>Shakes</span>

        <i class="fal fa-coffee-togo"></i>
      </div> -->
    </div>
    <span
      class="not_work"
      v-if="!info.restaurant.isavailable"
    >Currently unavailable to accept online orders.</span>
    <div class="container-order" v-for="category in menu.categories" :key="category.id">
      <h1>{{category.name}}</h1>
      <div class="container-product d-flex flex-wrap">
        <!-- Begin product -->
        <div
          class="product d-flex flex-row justify-content-between align-items-center"
          v-for="product in category.products"
          :key="product.id"
          @click="openFirstOrder(product)"
        >
          <div class="d-flex flex-column">
            <h1 class="title">{{product.name}}</h1>
            <div class="d-flex flex-row justify-content-between">
              <span class="subtitle">$ {{product.cost}}</span>
              <!-- <span class="subtitle">840 Calories</span> -->
            </div>
          </div>
          <!-- <img src="../../assets/images/sg_logo.svg" alt> -->
        </div>

        <!-- end product -->
      </div>
    </div>
    <div class="container-button d-flex flex-row align-items-center">
      <button type="button" class="btn-cont" @click="Payment">
        <span>Continue</span>
      </button>
      <div class="modify_link d-flex">
        <a href="#">Clear selected</a>
      </div>
    </div>
    <order-first ref="orderFirst"></order-first>
  </div>
</template>
<script>
import orderFirst from "./modals/orderFirst.vue";
import axios from "axios";
import { mapState } from "vuex";
import alert from "./custom/alert.vue";
export default {
  name: "order",
  components: {
    orderFirst: orderFirst,
    alert
  },
  data() {
    return {
      menu: {},
      color: null
    };
  },
  computed: {
    ...mapState(["info"]),
    cssProps() {
      return {
        "--main-color": this.info.color ? "#" + this.info.color : "#c12d39"
      };
    }
  },
  methods: {
    Payment() {
      if (this.info.products.length > 0) {
        // /baskets/{basketId}/products/batch or /baskets/{basketId}/products/bychainid ?
        // axios.put("https://secure-badlands-41449.herokuapp.com/baskets/" + this.info.basket.id + "/products/batch?includePrivate=false&key=SPn4GGKDfK4ubhbWD0GbiHofFQwk7INP", products)
        // .then(response => {
        //     thisRef.info.basket = response.data;
        // }).catch(error => {
        //     console.log(error)
        //     if(error.response.data.message){
        //         thisRef.$refs.alert.message = error.response.data.message;
        //         thisRef.$refs.alert.show();
        //     }
        // });
        this.$router.push({
          name: "payment"
        });
      } else {
        // this.$refs.alert.message = "Add at least one product to basket";
        this.$refs.alert.show();
      }
    },
    openFirstOrder(product) {
      this.$refs.orderFirst.show(product);
    }
  },
  created() {
    if (this.info.restaurant.id) {
      let thisRef = this;
      let restaurantId = this.info.restaurant.id;
      axios
        .get(
          `https://secure-badlands-41449.herokuapp.com/restaurants/${restaurantId}/menu?includePrivate=false&key=SPn4GGKDfK4ubhbWD0GbiHofFQwk7INP`
        )
        .then(response => {
          this.menu = response.data;
          console.log(this.menu)
        })
        .catch(error => console.log(error));
    }
  }
};
</script>
<style scoped>
.categories {
  width: 100%;
}
.itemCat {
  /* width: 138px; */
  height: 60px;
  padding: 19px;
  margin-top: 23px;
  margin-bottom: 40px;
}
.itemCat span {
  opacity: 0.8;
  color: #000000;
  font-family: Poppins;
  font-size: 15px;
  font-weight: bold;
  line-height: 23px;
}
.itemCat i {
  opacity: 0.8;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 20px;
  font-weight: 300;
  line-height: 21px;
  text-align: center;
}
.itemCat:hover{
  
	height: 60px;
	/* width: 138px; */
	border-radius: 8px;
	background-color: rgba(0,0,0,0.6);

}
.itemCat:hover span {
  color:white;
}
.itemCat:hover i{
  color:white;
}
.categories .itemCat:nth-child(3) i{
  padding-left:10px;
}

input:focus {
  outline: 0;
}
.search-item {
  width: 100%;
}
.search-block {
  box-sizing: border-box;
  height: 62px;
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  background-color: #ffffff;
  display: flex;
  justify-content: start;
  align-items: center;
}
.search-block i:first-child {
  height: 18px;
  width: 18px;
  opacity: 0.3;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 18px;
  line-height: 18px;
  margin-left: 25px;
  margin-right: 12px;
}

.search-block i:last-child {
  height: 18px;
  width: 18px;
  opacity: 0.3;
  /* color: #000000; */
  font-family: "Font Awesome 5 Pro";
  font-size: 18px;
  font-weight: 300;
  line-height: 18px;
}

.search-block input[type="search"] {
  border: none;
  width: 95%;
}
.search-block input::placeholder {
  font-family: "Poppins", sans-serif;
  color: #000000;
  opacity: 0.3;
  font-size: 16px;
  line-height: 25px;
}
.not_work {
  color: red;
  font-size: 12px;
  font-family: Poppins;
}
button {
  border: none;
  padding: 0;
  background: none;
  outline: none;
}
.product img {
  height: 60px;
  width: 80px;
}

.product {
  height: 76px;
  width: 330px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #ffffff;
  padding: 16px;
  margin-top: 10px;
  margin-left: 10px;
}

.product .title {
  opacity: 0.8 !important;
  color: #000000;
  font-family: Poppins;
  font-size: 16px !important;
  font-weight: bold;
  line-height: 15px;
}
.product .subtitle {
  opacity: 0.6 !important;
  color: #000000;
  font-family: Poppins;
  font-size: 13px !important;
  font-weight: 500;
  line-height: 20px;
}
.product .subtitle:nth-child(2) {
  padding-left: 10px;
}
.container-product {
  padding-top: 24px;
}
.container-order {
  padding-top: 32px;
}
.container-order h1 {
  opacity: 0.4 !important;
  color: #000000;
  font-family: Poppins;
  font-size: 16px !important;
  font-weight: bold;
  line-height: 25px;
}

.containerOne {
  padding: 47px;
  width: 100%;
  /* max-width: 958px; */
}
.containerOne h1 {
  text-transform: uppercase;
  opacity: 0.8;
  color: #000000;
  font-family: Poppins;
  font-size: 24px;
  font-weight: 800;
  line-height: 35px;
}
.containerOne h2 {
  opacity: 0.4;
  color: #000000;
  font-family: Poppins;
  font-size: 16px;
  line-height: 20px;
}
.container-button {
  padding-top: 48px;
  width: 100%;
}
.btn-cont {
  height: 48px;
  width: 201px;
  border-radius: 24px;
  background-color: var(--main-color);
}
.btn-cont span {
  color: #ffffff;
  font-family: Poppins;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
}
.modify_link {
  /* width: 10%; */
  padding-left: 10%;
}
.modify_link a {
  opacity: 0.4;
  color: #000000;
  font-family: Poppins;
  font-size: 12px;
  font-weight: 500;
  line-height: 25px;
  text-align: right;
  text-decoration: underline;
  white-space: nowrap;
}

.active {
  background-color: var(--main-color) !important;
}
.active i {
  color: #ffffff !important;
}
.active span {
  color: #ffffff !important;
}
@media screen and (max-width: 600px) {
  .containerOne {
    padding: 15px;
  }
  .container-product {
    width: 100%;
    padding: 0;
  }
  .product {
    width: 100%;
  }
  .containerOne h1 {
    text-align: center;
  }
  .containerOne h2 {
    text-align: center;
  }
  .container-button {
    flex-direction: column !important;
    margin-bottom: 80px;
  }
  .container-button .btn-cont {
    width: 100%;
  }
  .modify_link {
    padding-top: 15px !important;
    padding-left: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/steps/order.vue